export default "__VITE_ASSET__CKKCwLZN__"